<template>
    <div class="wave-navigation-component fix-to-top">
      <a class="link-to-main-site" v-if="!inFrame" href="https://ds.gongos.com/covid_site/default/behavioral">Back to Covid-19 Story</a>
        <button id="sitewhatsnewbutton" style="display:none;" v-on:click="gotoSection(sections[0].index)"></button>
        <ul v-if="!isMobile && sections.length > 0" :style="'width:' + (buttonWidth * 6).toString() + 'px; margin:0 auto; background-color:#ffffff;box-shadow:0 -1px 0 rgba(0,0,0,.1) inset;'">
            <li><a v-on:click="gotoSection(0)">What&#39;s New</a></li>
            <li><a v-on:click="gotoSection(1)">2020 Story</a></li>
            <li><a v-on:click="gotoSection(5)">Behavioral Groups</a></li>
            <li>
              <a v-on:click="showSections = !showSections">Lifestyle Categories</a>
              <input style="display:none;" type="checkbox" v-model="showSections" />
              <ul v-if="showSections">
                <li :style="'width:' + buttonWidth + 'px;'" :class="Number(currentWave) == i + 1 ? 'wave-item current-wave' : 'wave-item'" v-for="(w, i) in sections" :key="'waves' + i.toString()">
                    <a style="cursor:pointer;width:100%;display:block;" v-on:click="gotoSection(w.index)" >{{w.title}}</a>
                </li>
              </ul>
            </li>
            <li><a href="/corona_microsite?site=casestudy" target="_blank">Case Study</a></li>
            <li><a v-on:click="gotoSection(getSectionTotal() - 2)">About the Partnership</a></li>
        </ul>
        <!-- <img v-if="site == 'casestudy'" :style="isMobile ? 'display: block;margin: 0 auto;height: 25px;clear: both; margin-bottom: -25px;' : 'cursor:pointer;display: block;margin: 0 auto;height: 21px;clear: both; margin-bottom: -21px;'" src="/corona_microsite/static/images/gdpartnership.png" /> -->
        <img v-on:click="gotoSection(getSectionTotal() - (site == 'landing' ? 2 : 1))" :style="isMobile ? 'display: block;margin: 0 auto;height: 25px;clear: both; margin-bottom: -25px;' : 'cursor:pointer;display: block;margin: 0 auto;height: 21px;clear: both; margin-bottom: -21px;'" src="/corona_microsite/static/images/gdpartnership.png" />
    </div>
    <!-- <div v-if="isMobile" class="wave-navigation-component fix-to-top">
        <ul :style="'width:' + (buttonWidth * sections.length).toString() + 'px; margin:0 auto; background-color:#ffffff;box-shadow:0 -1px 0 rgba(0,0,0,.1) inset;'">
            <li :style="'width:' + buttonWidth + 'px;'" :class="Number(currentWave) == i + 1 ? 'wave-item current-wave' : 'wave-item'" v-for="(w, i) in sections" :key="'waves' + i.toString()">
                <a style="cursor:pointer;width:100%;display:block;" v-on:click="jumpToSection('#page_marker_' + w.title.split(' ').join('_'))">{{w.title}}</a>
            </li>
        </ul>
        <img v-on:click="gotoPartnership()" :style="isMobile ? 'display: block;margin: 0 auto;height: 25px;clear: both; margin-bottom: -25px;' : 'cursor:pointer;display: block;margin: 0 auto;height: 21px;clear: both; margin-bottom: -21px;'" src="/corona_microsite/static/images/gdpartnership.png" />
    </div>
    <div v-else class="wave-navigation-component fix-to-top">
        <ul v-if="!isMobile" :style="'width:' + (buttonWidth * sections.length).toString() + 'px; margin:0 auto; background-color:#ffffff;box-shadow:0 -1px 0 rgba(0,0,0,.1) inset;'">
            <li :style="'width:' + buttonWidth + 'px;'" :class="Number(currentWave) == i + 1 ? 'wave-item current-wave' : 'wave-item'" v-for="(w, i) in sections" :key="'waves' + i.toString()">
                <a style="cursor:pointer;width:100%;display:block;" v-on:click="gotoSection(w.index)" >{{w.title}}</a>
            </li>
        </ul>
        <img v-on:click="gotoPartnership()" :style="isMobile ? 'display: block;margin: 0 auto;height: 25px;clear: both; margin-bottom: -25px;' : 'cursor:pointer;display: block;margin: 0 auto;height: 21px;clear: both; margin-bottom: -21px;'" src="/corona_microsite/static/images/gdpartnership.png" />
    </div> -->
</template>
<script>
import GeneralUtils from '../components/utils/GeneralUtils'
import Sections from '../components/utils/Sections.js'
export default {
  props: ['sections', 'sectiontotal'],
  data () {
    return {
      buttonWidth: 160,
      isMobile: GeneralUtils.isMobile(),
      showSections: false,
      site: Sections.getSite(),
      inFrame: Sections.inFrame()
    }
  },
  methods: {
    gotoSection: function (index) {
      var listItems = document.querySelectorAll('.section-navigation > li')
      listItems[index].click()
      this.$data.showSections = false
    },
    gotoPartnership: function () {
      document.querySelector('#page_marker_About_the_Partnership').scrollIntoView()
    },
    jumpToSection: function (selector) {
      document.querySelector(selector).scrollIntoView()
    },
    getSectionTotal: function () {
      return document.querySelectorAll('.section-navigation > li').length
    }
  }    
}
</script>
<style lang="scss" scoped>
div.wave-navigation-component{
    background-color:#ffffff !important;
    box-shadow:0 -1px 0 rgba(0,0,0,.1) inset !important;
    position: absolute;
    width: 100%;
    left: 0;
    top:530px;
    z-index: 10000;
    > a{
      width: 30px;
      height: 30px;
      border-radius: 200px;
      padding: 0;
      text-align: center;
      font-size: 12px;
      background-color: #333;
      color: #fff;
      text-decoration: none;
      font-weight:bold;
      margin-top:10px;
    }
    > ul{
        margin: 0 auto;
        padding:0;
        width:1200px;
        max-width: 1200px;
        > li{
            display:inline-block;
            margin:0;
            text-align: center;
            float:left;
            padding: 6px 0;
            width:160px;
            position:relative;
            font-size:12px;
            > ul {
              position: absolute;
              top: 30px;
              background-color:#999999;
              padding:0;
              margin:0;
              > li{
                display:block;
                padding: 3px;
                margin:0;
                color:#ffffff;
                font-family: Gotham-Bold;
                box-shadow: 0 1px 0 rgba(0, 0, 0, .3); 
              }
            }
            
            > a{
                display:block;
                font-family:Gotham-Bold;
                font-size:12px;
                
                text-align:center;
                box-shadow: 1px 0 0 rgba(0,0,0,.2);
                cursor:pointer;
                width:100%;
                display:block;
                color: #333333 !important;
                text-decoration: none !important;
            }
            > label{
                display: block;
                font-family:Gotham-Light;
                font-size: 11px;
            }
        }
        > li:last-child{
          
          > a{
              box-shadow: none;
          }
        }
        > li.current-wave{
          background-color: rgba(210,210,210,.5);
          > a{
                color:#ffffff !important;
            }
            > label{
                color:#ffffff !important;
            }
        }
    }
    
}
div.wave-navigation-component.fix-to-top{
    position:fixed;
    top:0;
    background-color:rgba(255,255,255,.85);
    width: 100vw;
    box-shadow: 0 20px 10px #ffffff inset;
}
a.link-to-main-site{
  position: fixed;
  top: 0;
  left: 0;
  width: 200px !important;
  height: 22px !important;
  border-radius: 0 0 10px 0 !important;
  background-color: #ccc !important;
  margin: 0 !important;
  color: #333333 !important;
}
</style>
<style>
html,body{background-color:#ffffff !important;}
</style>



// WEBPACK FOOTER //
// src/custom/SiteNav.vue